import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPaymentCards = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 191 24" {...props}>
    <defs>
      <linearGradient id="payment-cards_svg__a" x1="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor="#00A0E5" />
        <stop offset="100%" stopColor="#0077C3" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(77)">
        <circle cx={12} cy={12} r={12} fill="#E61B25" />
        <circle cx={26.732} cy={12} r={12} fill="#F99F1B" />
        <path
          fill="#F26522"
          d="M19.366 2.537A11.98 11.98 0 0 1 24 12.01a11.98 11.98 0 0 1-4.634 9.474 11.98 11.98 0 0 1-4.634-9.474 11.98 11.98 0 0 1 4.634-9.474z"
        />
      </g>
      <path
        fill="#2B3894"
        d="m5.11 4.385 4.996 16.948h5.603l8.358-18.666h-5.592L13.27 15.428l-1.19-5.473-4.542-5.338z"
      />
      <path
        fill="#FAA61A"
        d="M.823 3.139v-.46h8.044c1.294.095 2.042.689 2.244 1.782.201 1.093.772 4.055 1.712 8.885-1.09-2.782-2.718-5.031-4.886-6.748C5.769 4.882 3.397 3.728.823 3.14z"
      />
      <path
        fill="#2B3894"
        d="M25.834 2.667h4.9l-3.09 18.666h-4.91zm20.899.814-.702 4.122c-1.293-.51-2.478-.819-3.554-.924-1.614-.159-3.808.238-3.992 1.53-.185 1.291 2.453 2.246 3.78 2.95 1.328.705 4.219 2.355 3.593 5.638-.626 3.283-2.53 4.587-5.63 5.448-3.099.862-7.488.273-9.495-.608.172-.94.424-2.37.758-4.285 1.93.855 3.521 1.282 4.775 1.282 1.882 0 3.707-.125 4.042-1.637.335-1.513-1.793-2.147-4.246-3.41-2.452-1.262-3.334-3.386-3.175-4.862.159-1.475 1.147-4.747 5.846-5.68 3.133-.622 5.8-.477 8 .436zm14.476-.814L65.4 21.333h-4.819l-.65-2.8h-6.65l-1.094 2.8h-5.454L54.4 4.302c.433-1.09 1.211-1.635 2.335-1.635h4.474zm-3.68 5.042-2.748 6.98h4.287l-1.54-6.98z"
      />
      <g fillRule="nonzero">
        <path
          fill="#37A72E"
          d="M171.927 11.112v10.083h5.51V15.22h6.246c2.628-.02 4.861-1.727 5.703-4.108h-17.46z"
        />
        <path
          fill="url(#payment-cards_svg__a)"
          d="M45.946 0c.318 4.098 4.122 7.333 8.768 7.333h9.504a6.32 6.32 0 0 0 .106-1.16c0-3.395-2.687-6.148-6.012-6.173H45.946z"
          transform="translate(125.98 2.862)"
        />
        <path
          fill="#37A72E"
          d="m162.874 10.153.005-.01a.34.34 0 0 1 .636.155v10.897h5.655V2.862h-5.655c-.717.024-1.527.546-1.829 1.187l-4.5 9.578a.371.371 0 0 1-.05.108l-.002.004a.377.377 0 0 1-.688-.214V2.862h-5.654v18.333h5.654v-.002c.71-.037 1.5-.553 1.798-1.185l4.618-9.83a.334.334 0 0 1 .012-.025zm-20.18.313-3.235 10.73h-3.983L132.24 10.46a.366.366 0 0 0-.358-.302.367.367 0 0 0-.365.374v10.663h-5.535V2.862h6.166c1.019 0 2.086.801 2.384 1.788l2.694 8.934c.134.445.351.444.485 0l2.694-8.934c.298-.987 1.365-1.788 2.384-1.788h6.165v18.333h-5.535V10.527a.367.367 0 0 0-.364-.37.367.367 0 0 0-.36.31z"
        />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgPaymentCards);
export default Memo;
